module.exports = __webpack_public_path__ + "img/04.2fb4ed3f.jpg";